/**
 * @voltxampere/ui — MoveCommand (Sprint 13)
 *
 * Translate a single component's position. DragTool wraps a
 * BatchCommand of N MoveCommand for multi-select drags.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class MoveCommand {
    componentId;
    fromPosition;
    toPosition;
    constructor(componentId, fromPosition, toPosition) {
        this.componentId = componentId;
        this.fromPosition = fromPosition;
        this.toPosition = toPosition;
    }
    do(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => c.id === this.componentId ? { ...c, position: { ...this.toPosition } } : c),
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => c.id === this.componentId ? { ...c, position: { ...this.fromPosition } } : c),
        };
    }
    describe() {
        return "Taşındı";
    }
}
//# sourceMappingURL=move.js.map